import api from '@/api';

const { $pricing, $commission } = api;

export const { $types } = $pricing;
export const { $commissionPrizes } = $commission;